import React from 'react';
import { Conversation } from '../../types';
import ConversationList from './ConversationList.tsx';
import NewMessageModal from './NewMessageModal.tsx';

export type ConversationsListPanelProps = {
  conversations: Conversation[];
  selectedId?: string;
  isMobile: boolean;
  isReactivatingAll: boolean;
  onReactivateAll: () => void;
  onSelectConversation: (conversation: Conversation) => void;
  newMessageModalOpen: boolean;
  onOpenNewMessageModal: () => void;
  onCloseNewMessageModal: () => void;
  onSendNewMessage: (data: { telefone: string; nome: string; mensagem: string }) => Promise<void>;
};

export default function ConversationsListPanel({
  conversations,
  selectedId,
  isMobile,
  isReactivatingAll,
  onReactivateAll,
  onSelectConversation,
  newMessageModalOpen,
  onOpenNewMessageModal,
  onCloseNewMessageModal,
  onSendNewMessage,
}: ConversationsListPanelProps) {
  return (
    <>
      <div className="p-3 border-b border-gray-200 bg-white">
        <button
          onClick={onReactivateAll}
          disabled={isReactivatingAll}
          className="w-full flex items-center justify-center px-3 py-2 bg-green-600 text-white rounded font-medium hover:bg-green-700 transition-colors text-xs"
        >
          {isReactivatingAll ? 'Reativando...' : 'Reativar IA em Todas'}
        </button>
      </div>
      <div className="flex-1 min-h-0 overflow-y-auto">
        <ConversationList
          conversations={conversations}
          selectedId={selectedId}
          onSelectConversation={onSelectConversation}
          onOpenNewMessageModal={onOpenNewMessageModal}
          className={isMobile ? 'w-full border-r-0 border-b border-gray-200' : ''}
        />
      </div>
      <NewMessageModal
        open={newMessageModalOpen}
        onClose={onCloseNewMessageModal}
        onSend={onSendNewMessage}
      />
    </>
  );
}
